import { styled, keyframes, SpacingStack, FormControl } from '@withjoy/joykit';

export const StyledFormControl = styled(FormControl)`
  .intl-tel-input,
  .iti {
    width: 100%;
    .country-list {
      white-space: normal;
    }
  }
  .iti__tel-input {
    padding-left: 48px !important;
  }
  input {
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-color: #d9d9d9;
    border-radius: ${props => props.theme.radii[3]};
    height: 50px;
    box-shadow: ${props => (props.isInvalid ? '0px 0 0px 2px rgba(197,0,32,1)' : 'none')};
  }
  input:focus {
    outline: 0;
  }
`;

const fadeIn = keyframes`
  0% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
`;

export const StyledContainer = styled(SpacingStack)`
  animation: ${fadeIn} ease 1s;
`;
